import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import useForm from '../../hooks/useForm'
import ClusterDoorForm from './ClusterDoorForm'
import { createCluster } from '../../common/redux/collectionActions'

const doorNames = 'abcdefghijklmnopqrstuvwxyz'.split('')

const placeholderTexts = {
  custom_name: 'Namn på kluster',
  location: 'Platsbeskrivning',
  street: 'Adress',
  zip: 'Postnummer',
  city: 'Stad',
  publicKeys: 'Styrenheter (ex. dcf4debe; ecf6uyba)',
  doorsQty: 'Antal dörrar',
}

const initialState = {
  custom_name: '',
  location: '',
  street: '',
  zip: '',
  city: '',
  publicKeys: '',
  doorsQty: '',
}

const CreateCluster = () => {
  const [formValues, onFormChange, resetForm] = useForm(initialState)
  const [isLoading, setIsLoading] = useState(false)
  const [doorData, setDoorData] = useState({})
  const dispatch = useDispatch()

  const onSubmit = () => {
    setIsLoading(false)

    dispatch(createCluster({ ...formValues, doors: Object.values(doorData) }, resetForm))
  }

  useEffect(() => {
    /* set default values for dynamic number of doors */
    const defaultDoorData = doorNames.slice(0, Number(formValues.doorsQty)).reduce((acc, door, i) => {
      const existingData = doorData[door]

      if (existingData) return { ...acc, [door]: existingData }

      return { ...acc, [door]: { display_name: `Fack ${i + 1}`, controller_index: '-1', height: '100', width: '100', depth: '100' } }
    }, {})

    setDoorData(defaultDoorData)
  }, [formValues.doorsQty])

  const doorsQty = Number(formValues.doorsQty)
  const doorDisplayNames = Object.values(doorData).map((d) => d.display_name)
  const isDisabled = isLoading || Object.values(doorData).some((d) => !d.display_name) || new Set(doorDisplayNames).size !== doorDisplayNames.length
  const parsedPublicKeys = ['Styrenhet'].concat(formValues.publicKeys.split(';').filter((key) => key))

  return (
    <div>
      <h2>Allmän information</h2>
      <div className="flex" style={{ flexWrap: 'wrap' }}>
        {Object.entries(formValues).map(([key, val]) => (
          <input style={{ width: '30%', margin: 10 }} placeholder={placeholderTexts[key]} className="change-input form-control" key={key} type="text" name={key} value={val} onChange={onFormChange} />
        ))}
      </div>

      {doorsQty > 0 && <h2>Fack</h2>}
      {doorsQty > 0
        && doorNames.slice(0, doorsQty).map((doorName) => (
          <ClusterDoorForm
            key={doorName}
            door={doorData[doorName]}
            publicKeys={parsedPublicKeys}
            onChange={({ target }) =>
              setDoorData({
                ...doorData,
                [doorName]: {
                  ...doorData[doorName],
                  [target.name]: target.value,
                },
              })
            }
          />
        ))}

      {doorsQty > 0 && (
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <button disabled={isDisabled} className="smallQbutton" style={{ background: isLoading && 'grey', marginTop: 20 }} onClick={onSubmit}>
            Skapa kluster
          </button>
        </div>
      )}
    </div>
  )
}

export default CreateCluster
